module.exports = __webpack_public_path__ + "static/media/video/how_to_validate.mp4";